<template>
  <div id="gtn-gj-id" class="side-bar-wrapper" :style="{ bottom: !gjShow ? '-110px' : '100px' }">
    <div style="position: relative; left: 20px">
      <img style="width: 60px" src="~@/assets/index/sidepng.png" />
      <a href="#" v-show="codeShow" class="footer-item footer-code">
        <img src="@/assets/index/wx_qr_code.jpg" class="footer-code-hover" alt />
      </a>
      <a v-show="gjShow" :href="kfUrl" class="footer-item footer-kf" target="_blank"
        @click.stop="gioTrackEvent('OP_onlineServiceClick')">
        <img class="footer-hover-kf" src="@/assets/new/kefu.png" alt />
      </a>
      <a v-show="gjShow" href="#" class="footer-item footer-gj" @click.stop="popWorkOrder">
        <img class="footer-hover-gj" src="@/assets/new/gongdan.png" alt />
      </a>
      <a v-show="showPhotonGj" :href="photonUrl" target="_blank" class="guanzi-item" @click="handleTrack('PC_挂件_光子商城')">
        <img style="width: 62px" src="~@/assets/index/guanzi.png" />
      </a>
      <div v-show="topShow" class="footer-bottom" @click.stop="goTop">
        <img style="width: 60px" src="~@/assets/index/side-back.png" />
      </div>
    </div>
  </div>
</template>
<script>
import _ from 'lodash'
import { mapGetters } from 'vuex'
import { config } from '@/api/service'
export default {
  name: 'VideoPlayer',
  data() {
    return {
      photonUrl: window.LOCAL_CONFIG.PHOTON_URL,
      topShow: false,
      kfUrl: window.LOCAL_CONFIG.serviceUrl,
      gjShow: true,
      showPhotonGj: false,
      codeShow: true,
    }
  },
  computed: {
    ...mapGetters(['user']),
  },

  created() {
    config('whether_display_pho_pendant').then(res => {
      this.showPhotonGj = res.whether_or_not === '1'
    })
  },
  mounted() {
    let curRoute = this.$route.matched[0] && this.$route.matched[0].path
    if (curRoute === '/console') {
      this.gjShow = false
    }
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll)
    })
  },

  methods: {
    // 光子中心
    memberCenter() {
      if (!this.user.hsid) {
        this.$goLoginUrl()
      }
    },

    popWorkOrder() {
      this.gioTrackEvent('OP_issueTicketSubmit')
      window.location.href = window.origin + '/openplat-front/workOrder/submitWorkOrder'
    },
    getClientHeight() {
      let clientHeight = 0
      if (document.body.clientHeight && document.documentElement.clientHeight) {
        clientHeight =
          document.body.clientHeight < document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight
      } else {
        clientHeight =
          document.body.clientHeight > document.documentElement.clientHeight
            ? document.body.clientHeight
            : document.documentElement.clientHeight
      }
      return clientHeight
    },
    handleScroll: _.debounce(function () {
      // 获取滚动时的高度
      let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      let screenHeight = this.getClientHeight()
      this.topShow = scrollTop > screenHeight ? true : false
      if (scrollTop > screenHeight) {
        this.$emit('overScreenSight')
      }
    }, 300),
    goTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.footer-bottom {
  cursor: pointer;
}

.footer-item {
  display: inline-block;
  width: 40px;
  height: 48px;
  position: absolute;
  left: 5px;
  top: 4px;
  transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}

.footer-item:hover .footer-hover-kf,
.footer-item:hover .footer-hover-gj,
.footer-item:hover .footer-code-hover {
  width: 135px;
  opacity: 1;
  transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
}

.footer-code-hover {
  width: 0px;
  transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  position: relative;
  left: -140px;
  top: -80px;
}

.footer-kf {
  top: 60px;
}

.footer-hover-kf {
  width: 0px;
  transition: all 0.3s cubic-bezier(0.25, 1, 0.5, 1);
  opacity: 0;
  position: relative;
  left: -120px;
  top: 10px;
}

.footer-gj {
  top: 120px;
}

.footer-hover-gj {
  opacity: 0;
  width: 0px;
  position: relative;
  left: -120px;
  transition: all 0.3s;
}

.side-bar-wrapper {
  width: 70px;
  position: fixed;
  right: 20px;
  height: 200px;
  z-index: 999;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .guanzi-item {}

  .side-bar-item {
    display: block;
    width: 70px;
    height: 70px;
    color: #2789ff;
    background: #fff;
    cursor: pointer;
    margin-bottom: 8px;
    text-align: center;
    font-size: 12px;

    img {
      width: 24px;
      margin-top: 14px;
    }

    &:hover {
      background: #e9f3ff;
    }
  }

  .work {
    background: #2789ff;
    color: #fff;

    &:hover {
      background: #3c93fc;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/components/backToTop.vue